import { BrowserRouter as Router, useParams } from 'react-router-dom';
import Routes from './Routes';
import LandingScreen from './pages/landingPage/LandingScreen';
import Nft from './pages/nft';
import Chime from './pages/chime';
import Header from './components/header';
import OtherBar from './components/header/otherbar';
import { authenticate, userSession, logout } from './services/auth';
import Profile from './pages/profile';
import { useEffect, useMemo, useState } from 'react';
import { fetchData } from './services/stacks';
import { clientNetwork, sentimentApi, stacksApi, stacksExplorer } from './lib/constants';
import Exhibit from './pages/exhibit';

const appOrigin = window.location.origin;

const App = () => {
  const isAuthenticated = userSession.isUserSignedIn();
  const pathSegments = window.location.pathname.split('/');
  const contractId = pathSegments[2] || null;
  const nftId = pathSegments[3] || null;
  const exhibit = { author: pathSegments[1], filename: pathSegments[3] } || null;

  console.log({ pathSegments });

  const [replyOpen, setReplyOpen] = useState(false);
  const [userSettings, setUserSettings] = useState(null);

  useEffect(() => {
    init();
  }, [])

  async function init() {
    const localUserSettings = localStorage.getItem(appOrigin) || null;
    if (localUserSettings !== null) {
      setUserSettings(JSON.parse(localUserSettings));
    } else {
      fetchData('settings.json', { encrypt: false })
        .then(({ success, result }) => {
          if (success) {
            localStorage.setItem(appOrigin, JSON.stringify(result));
            setUserSettings(result);
          } else {
            // Default user settings
            setUserSettings({ stacksApi: stacksApi[clientNetwork], stacksExplorer: stacksExplorer, sentimentApi: sentimentApi });
          }
        })
    }
  }

  console.log("here");

  return (
    <div className="App">
      {isAuthenticated ? (
        <article>
          <Router>
            <div className="headerContainer">
              <Header authenticate={authenticate} isAuthenticated={isAuthenticated} logout={logout} replyOpen={replyOpen} />
            </div>
            <div className="routesContainer">
              <Routes setReplyOpen={setReplyOpen} userSettings={userSettings} setUserSettings={setUserSettings} />
            </div>
          </Router>
        </article>
      ) : (
        <>
          {pathSegments[1] !== '' && <OtherBar />}
          {pathSegments[1] === 'nft' && <Router><Nft contractId={contractId} nftId={nftId} /></Router>}
          {pathSegments[1].includes('0x') && <Router><Chime txId={pathSegments[1]} setReplyOpen={setReplyOpen} userSettings={userSettings} /></Router>}

          {pathSegments[2] === 'exhibit' && <Router><Exhibit unAuthAuthor={exhibit.author} unAuthFilename={exhibit.filename} /></Router>}

          {(pathSegments[1].includes('.') || pathSegments[1].includes('SP') && (pathSegments[2] !== 'exhibit')) && <Profile address={pathSegments[1]} setReplyOpen={setReplyOpen} userSettings={userSettings} />}
          {(pathSegments[1].includes('.') || pathSegments[1].includes('ST') && (pathSegments[2] !== 'exhibit')) && <Profile address={pathSegments[1]} setReplyOpen={setReplyOpen} userSettings={userSettings} />}
          {pathSegments[1] === '' && <LandingScreen />}
        </>
      )}
    </div>
  );
}

export default App;
